import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Paprika } from '../../styles/theme';

export type BubbleTone = 'say' | 'live' | 'hot' | 'grave';

interface Props {
  tone?: BubbleTone;
  children: React.ReactNode;
  testID?: string;
}

/**
 * What Du Chef says on a screen. `say`/`live` is the neutral card with a
 * terracotta rule; `hot` tints after the cook answers; `grave` is the
 * allergy tone — alert tint and border, never playful.
 */
export function DuChefBubble({ tone = 'say', children, testID }: Props) {
  const grave = tone === 'grave';
  const hot = tone === 'hot';
  return (
    <View
      style={[styles.bubble, hot && styles.hot, grave && styles.grave]}
      testID={testID}
      accessibilityRole="text"
    >
      <View style={[styles.rule, grave && styles.ruleGrave]} />
      <Text style={[styles.text, grave && styles.textGrave]}>{children}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  bubble: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
    backgroundColor: Paprika.cardBg,
    borderRadius: 14,
    paddingVertical: 12,
    paddingHorizontal: 14,
    shadowColor: 'rgba(82, 68, 60, 1)',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
  },
  hot: { backgroundColor: Paprika.brandTint },
  grave: { backgroundColor: Paprika.approvalNoTint, borderWidth: 1, borderColor: Paprika.approvalNo },
  rule: { width: 3, alignSelf: 'stretch', borderRadius: 2, backgroundColor: Paprika.accent, marginTop: 2 },
  ruleGrave: { backgroundColor: Paprika.approvalNo },
  text: { flex: 1, fontFamily: 'Newsreader-Italic', fontSize: 17, lineHeight: 24, color: Paprika.textPrimary },
  textGrave: { color: Paprika.approvalNo, fontFamily: 'Newsreader-Regular' },
});
